import {saveUserLS} from '@asocial/fe-utils'
import {FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import {setUser, UploadBanner, useUser} from 'entities/user'
import {EditButton} from 'features/buttons/editButton'
import {GetDirectUploadUrlPhoto, UploadMediaToBucket} from 'shared/api/images'
import {Me} from 'shared/types'

type EditButtonProps = {
  className?: string
}

export const EditBannerButton: FC<EditButtonProps> = ({className}) => {
  const dispatch = useDispatch()
  const user = useUser()
  const [isLoading, setIsLoading] = useState(false)

  const updateUser = (user: Me) => {
    dispatch(setUser(user))
    saveUserLS(user)
  }

  const onSave = async (file: File) => {
    setIsLoading(true)
    const {data: uploadUrls} = await GetDirectUploadUrlPhoto({count: 1, mediaType: 'banner'})
    const [{uploadUrl, key}] = uploadUrls

    await UploadMediaToBucket(uploadUrl, file)

    const {data: banner} = await UploadBanner(key)
    updateUser({
      ...user,
      profile: {...user.profile, bannerUrl: banner.image.url}
    })
    setIsLoading(false)
  }

  const editBannerHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!(event.target.files && event.target.files.length > 0)) return
    onSave(event.target.files[0])
    event.target.value = ''
  }

  return <EditButton className={className} onChange={editBannerHandler} isLoading={isLoading} />
}
